// @ts-nocheck
import globalVariables from "@/global";

export const PASSWORD_MIN_LENGTH_DEFAULT = 8;
export const PASSWORD_MIN_LENGTH_ENHANCED = 14;

const PasswordConditions = (key = 'password') => ({
		computed: {

			passwordHasXCharsNoSpace() {
				if (this.passwordMinimumLengthIncreaseFeatureEnabled) {
					return (this.data[key] || '').length >= PASSWORD_MIN_LENGTH_ENHANCED && !/\s/.test(this.data[key]);
				}
				return (this.data[key] || '').length >= PASSWORD_MIN_LENGTH_DEFAULT && !/\s/.test(this.data[key]);
			},

			passwordHasNumber() {
				return /\d/.test(this.data[key] || '');
			},

			passwordHasUppercase() {
				return /[A-Z]/.test(this.data[key] || '');
			},

			passwordHasSpecialChar() {
				return /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(this.data[key] || '');
			},

			passwordIsValid() {
				if (this.passwordMinimumLengthIncreaseFeatureEnabled) {
					return this.passwordHasXCharsNoSpace
						&& this.passwordHasNumber
						&& this.passwordHasUppercase
						&& this.passwordHasSpecialChar
				}
				return this.passwordHasXCharsNoSpace
					&& this.passwordHasNumber
					&& this.passwordHasSpecialChar;
			},

			passwordConditions() {
				if (this.passwordMinimumLengthIncreaseFeatureEnabled) {
					return [
						{
							valid: this.passwordHasXCharsNoSpace,
							text: this.$i18n.t('mixins.passwordConditions.xCharsNoSpace', {amount: PASSWORD_MIN_LENGTH_ENHANCED}),
						},
						{
							valid: this.passwordHasNumber,
							text: this.$i18n.t('mixins.passwordConditions.atLeast', {amount: 1}),
						},
						{
							valid: this.passwordHasUppercase,
							text: this.$i18n.t('mixins.passwordConditions.hasUppercase')
						},
						{
							valid: this.passwordHasSpecialChar,
							text: this.$i18n.t('mixins.passwordConditions.hasSpecialChar'),
						},
					];
				}
				return [
					{
						valid: this.passwordHasXCharsNoSpace,
						text: this.$i18n.t('mixins.passwordConditions.xCharsNoSpace', {amount: PASSWORD_MIN_LENGTH_DEFAULT}),
					},
					{
						valid: this.passwordHasNumber,
						text: this.$i18n.t('mixins.passwordConditions.atLeast', {amount: 1}),
					},
					{
						valid: this.passwordHasSpecialChar,
						text: this.$i18n.t('mixins.passwordConditions.hasSpecialChar'),
					},
				];
			},
		},
		passwordMinimumLengthIncreaseFeatureEnabled() {
			this.pwdLengthUpdateFF = globalVariables.websiteConfig.featureFlagEnabled('co-4467-update-minimum-pwd-requirement');
		},
});

export default PasswordConditions;
